export const TILSYN_META_DATA = {
  erklaeringAar: "2025",
  fristDato: "20.04.2025",
};
